<template>
  <div v-if="commandeTlpe">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{  $t('editCommandeTlpe.title', { code: commandeTlpe.code }) }}
                <b-tag v-if="getLibelleEtat"
                       type="has-background-subMenu"
                       class="has-text-white mgl-5px">
                  {{ getLibelleEtat }}
                </b-tag>
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <a class="button" @click="$router.go(-1)">
            {{ $t('general.button.cancel') }}
          </a>
          <a class="button is-addOrEdit mgl-10px"
             @click="checkPermissions(constantes.COMMANDE_TLPE.maj) ? save()
                  : showPopUp()">
            {{ $t('general.button.sauvegarder') }}
          </a>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages" class="mgt-20px"
                         :error="error"
                         :title="'general.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="tab">
      <ul>
        <li :class="[{'is-active': activeTab === 'AppInfo'}]"
          @click="activeTab = 'AppInfo'">
          {{ $t('editCommandeTlpe.tabs.quotation') }}
        </li>
        <li :class="[{'is-active': activeTab === 'AppEcheancier'}]"
           @click="activeTab = 'AppEcheancier'">
          {{ $t('editCommandeTlpe.tabs.echeancierTlpe') }}
        </li>
      </ul>
    </div>
    <keep-alive>
      <component
        :commandeTlpe="commandeTlpe"
        :is="activeTab"
        :showErrorDate="false"
      />
    </keep-alive>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { DEVIS_COMMANDE_ETAT } from '@/configuration/devisConf';
import breadcrumb from '@/components/general/breadcrumb';
import { get, update } from '@/api/gabed/commandeTlpe';
import messageErreur from '@/services/general/messageErreur';
import { COMMANDE_TLPE } from '@/configuration/gabed/permissionsGabedConf';
import AppInfo from '@/components/gabed/commandeTlpe/edition/infoCommandeTlpe';
import AppEcheancier from '@/components/gabed/commandeTlpe/edition/echeancierCommandeTlpe';
import formateCommandeTlpeForFront from '@/services/gabed/commandeTlpe/formateCommandeTlpeForFront';
import formateCommandeTlpeForUpdate
  from '@/services/gabed/commandeTlpe/formateCommandeTlpeForUpdate';
import messageSucces from '@/services/general/messageSucces';
import validationGeneral from '@/services/validation/validation';
import validation from '@/services/gabed/commandeTlpe/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');

export default {
  data() {
    return {
      commandeTlpe: null,
      error: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      constantes: {
        COMMANDE_TLPE,
      },
      activeTab: null,
    };
  },
  components: {
    breadcrumb,
    errorMsgComponent,
    AppEcheancier,
    AppInfo,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getLibelleEtat() {
      const etatFind = DEVIS_COMMANDE_ETAT.find((etat) => {
        return etat.code === this.commandeTlpe.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('editCommandeTlpe.breadcrumb.liste'), route: { name: 'l.gabed.commande_tlpe' }, isActive: false },
        { title: this.$t('editCommandeTlpe.breadcrumb.edit'), route: '', isActive: true },
      ];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      showAddAttachmentModal: 'showAddModal',
    }),
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const commande = formateCommandeTlpeForUpdate(this.commandeTlpe);
        await update(commande);
        messageSucces(this.$i18n.t('editCommandeTlpe.messages.success.edit'));
        loadingComponent.close();
        await this.$router.push({ name: 'c.gabed.commande_tlpe', params: { id: commande.id } });
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.activeTab = 'AppInfo';
      await this.setAttachmentContext({ module: 'Commande' });
      await this.setAttachmentElementId({ id: this.$route.params.id });
      const commandeTlpe = (await get(this.$route.params.id)).data.result;
      commandeTlpe.echeanciers.map(echeancier => {
        echeancier.openEcheancierLignes = false;
        echeancier.select = false;
        echeancier.dateDebut = new Date(echeancier.dateDebut);
        echeancier.dateFin = new Date(echeancier.dateFin);
        echeancier.dateFinPremiereEcheance = new Date(echeancier.dateFinPremiereEcheance);
        echeancier.echeancierLignes.map(echeancierLigne => {
          echeancierLigne.dateDebut = new Date(echeancierLigne.dateDebut);
          echeancierLigne.dateFin = new Date(echeancierLigne.dateFin);
          echeancierLigne.datePrevisionnelleFacturation = new Date(
            echeancierLigne.dateDebut);
          echeancierLigne.dateBonAFacturer = new Date(echeancierLigne.dateBonAFacturer);
          return echeancierLigne;
        });
        return echeancier;
      });
      this.commandeTlpe = formateCommandeTlpeForFront(commandeTlpe);
      this.setInformationPage(this.$t('pageGeneral.modification', { item: this.commandeTlpe.code }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};

</script>
